//@ts-nocheck
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import queries from './queries.json';
import { setGoal } from './fathom';

export async function request(token: string, key: string | null, jsonQuery: any = {}) {
  const subgraphUrl = !token || (token && token.toLowerCase() === 'buni') ? process.env.REACT_APP_SUBGRAPH_URL : process.env.REACT_APP_SUBGRAPH_URL_BUR;
  jsonQuery = key
    ? merge(cloneDeep(queries[key]), cloneDeep(jsonQuery))
    : jsonQuery;
  const query =
    typeof jsonQuery === 'string'
      ? jsonQuery
      : jsonToGraphQLQuery({ query: jsonQuery });
  const res = await fetch(subgraphUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  });
  try {
    const { data } = await res.json();
    return data;
  } catch (e) {
    setGoal('TPVLQU4A');
    return Promise.reject(e);
  }
}
